import { render, staticRenderFns } from "./VirtualMachineMemoryUsageTop.vue?vue&type=template&id=1f4c2756"
import script from "./VirtualMachineMemoryUsageTop.vue?vue&type=script&lang=js"
export * from "./VirtualMachineMemoryUsageTop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports